

































































































































































































































































































import Card from '@/components/UI/Card.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue';
import '@/extensions';
import {
    CalcIndividualConfig,
    IndividualConfig,
    Sales,
    Promotions,
    SaleIndividualConfig,
    SaleServerIndividualConfig,
    PromotionIndividualConfig,
    PromotionsServerIndividualConfig,
    PromoType,
} from '@/interfaces/global-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';
import {
    IModuleItemsStaticTableFilterOptions,
    TModuleType,
    IModuleItemResponseDto,
    IModuleItemTableItem,
    IModuleItemFiltersInLevels,
} from "@/pages/ModuleItems/data";
import ModuleApi from "@/pages/ModuleItems/ModuleApi";
import moment from "moment";
import {
    ModuleItemCalculationStartParams,
    ModuleItemFilters,
    SaveModuleItemParamsFilter
} from '@/interfaces/server-data';
import {Modal} from "ant-design-vue";
import { isEqual } from 'lodash';

@Component({
    components: {
        vSelect,
        CollapseCard,
        Card,
        ColumnTitleContent,
    },
})

export default class ItemsListTable extends Mixins(LocalData, Http) {
    @Prop() readonly moduleType!: TModuleType;
    @Prop({required: true}) readonly filters!: IModuleItemFiltersInLevels;
    @Prop({required: true}) readonly api!: ModuleApi;

    get moduleData(): Sales | Promotions {
        if (this.moduleType === 'promo') {
            return this.$promotions;
        } else {
            return this.$sales;
        }
    }

    set moduleData(data: Sales | Promotions) {
        if (this.moduleType === 'promo') {
            this.$promotions = data as Promotions;
        } else {
            this.$sales = data as Sales;
        }
    }

    // For promo returns selected calculation type; for sales returns null (stub)
    get calculationType() {
        return this.moduleType === 'promo' ? (this.moduleData as Promotions).calculationType : null;
    }

    private componentTexts = {
        sales: {
            deleteConfirmContent: this.$t('modules.deleteSaleConfirmText') as string,
            deleteSuccess: this.$t('sales.deleteSuccess') as string,
            deleteError: this.$t('sales.deleteError') as string,
            fetchItemsError: this.$t('sales.fetchError') as string,
        },
        promo: {
            deleteConfirmContent: this.$t('modules.deletePromotionConfirmText') as string,
            deleteSuccess: this.$t('promo.deleteSuccess') as string,
            deleteError: this.$t('promo.deleteError') as string,
            fetchItemsError: this.$t('promo.fetchError') as string,
        },
    };

    get tableFilterValuesToBeWatched () {
        return Object.assign({}, this.tableFilterValues)
    }

    private someFiltersStates: any = {
        groupIds: [],
        categoryIds: [],
        subcategoryId: null,
        formatId: null,
        regionIds: [],
        clusterIds: [],
    };

    @Watch('tableFilterValuesToBeWatched',{deep: true})
    onTableFilterValuesChanged(value: any, oldValue: any) {
        this.someFiltersStates.groupIds = value.groupIds;
        this.someFiltersStates.categoryIds = value.categoryIds;
        this.someFiltersStates.subcategoryId = value.subcategoryId;
        this.someFiltersStates.formatId = value.formatId;
        this.someFiltersStates.regionIds = value.regionIds;
        this.someFiltersStates.clusterIds = value.clusterIds;

        if (!LocalData.compareTwoArrays(value.groupIds, oldValue.groupIds)) {
            if (!!this.filters.groupIds.length && !LocalData.compareTwoArrays(value.groupIds, this.filters.groupIds)) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (!LocalData.compareTwoArrays(value.categoryIds, oldValue.categoryIds)) {
            if (!!this.filters.categoryIds.length && !LocalData.compareTwoArrays(value.categoryIds, this.filters.categoryIds)) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (value.subcategoryId !== oldValue.subcategoryId) {
            if (oldValue.subcategoryId !== -1 && value.subcategoryId !== this.filters.subcategory) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (value.formatId !== oldValue.formatId) {
            if (oldValue.formatId !== -1 && value.formatId !== this.filters.formatSelected) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (!LocalData.compareTwoArrays(value.regionIds, oldValue.regionIds)) {
            if (!!this.filters.regionIds.length && !LocalData.compareTwoArrays(value.regionIds, this.filters.regionIds)) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (!LocalData.compareTwoArrays(value.clusterIds, oldValue.clusterIds)) {
            if (!!this.filters.clusterIds.length && !LocalData.compareTwoArrays(value.clusterIds, this.filters.clusterIds)) {
                this.$emit('reset-filters', true);
                return;
            }
        }
    }

    get prevFetchTableFilterValuesToBeWatched () {
        return this.moduleType === 'promo' ? Object.assign({}, this.prevFetchTableFilterValues) : {};
    }

    @Watch('prevFetchTableFilterValuesToBeWatched',{deep: true})
    onPrevFetchTableFilterValuesChanged(value: any, oldValue: any) {
        if (!isEqual(value, oldValue)) {
            this.resetIncludedAndExcludedCheckboxes();
        }
    }

    private defaultTableState = {
        sortField: 'id',
        isAsc: false,
        page: 0,
        size: 10,
    };

    private tableState = {
        sortField: 'id',
        isAsc: false,
        page: 0,
        size: 10,
    };

    isCommonCheckboxSelected: boolean = false;
    includedIds: number[] = [];
    excludedIds: number[] = [];

    private staticTableFilterOptions: IModuleItemsStaticTableFilterOptions = {
        promo: {
            statuses: [
                {
                    value: 'ACTIVE',
                    label: this.$t('shared.labels.active') as string,
                },
                {
                    value: 'STOPPED',
                    label: this.$t('shared.labels.stopped') as string,
                },
                {
                    value: 'PLANNED',
                    label: this.$t('shared.labels.planned') as string,
                },
            ],
            types: [
                {
                    value: 'PRICE',
                    label: this.$t('shared.itemsList.priceType') as string
                },
                {
                    value: 'DISCOUNT',
                    label: this.$t('shared.itemsList.discountPercent') as string
                },
            ],
        },
        sales: {
            statuses: [
                {
                    value: 'ACTIVE',
                    label: this.$t('shared.labels.active') as string,
                },
                {
                    value: 'STOPPED',
                    label: this.$t('shared.labels.stopped') as string,
                },
                {
                    value: 'PLANNED',
                    label: this.$t('shared.labels.planned') as string,
                },
            ],
            types: [
                {
                    value: 'SALE',
                    label: this.$t('shared.labels.sale') as string
                },
                {
                    value: 'FLASH_SALE',
                    label: this.$t('shared.itemsList.saleBomb') as string
                },
                {
                    value: 'MARKDOWN',
                    label: this.$t('shared.itemsList.saleDeassortment') as string
                },
                {
                    value: 'DISCONTINUED',
                    label: this.$t('shared.itemsList.saleMarkdown') as string
                },
                {
                    value: 'SEASONAL',
                    label: this.$t('shared.itemsList.saleSeason') as string,
                },
            ],
        }
    };

    private tableFilterOptions = {};

    private defaultTableFilterValues = {
        id: null,
        name: null,
        types: [],
        startDate: null,
        endDate: null,
        remains: null,
        stagesNumber: null,
        statuses: [],
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minPromotionDiscount: null,
        maxPromotionDiscount: null,
        minMargin: null,
        groupIds: [],
        categoryIds: [],
        // subcategoryIds: [],
        subcategoryId: null,
        // formatIds: [],
        formatId: null,
        regionIds: [],
        // regionId: null,
        clusterIds: [],
        // clusterId: null,
    };

    private tableFilterValues: any = {
        id: null,
        name: null,
        types: [],
        startDate: null,
        endDate: null,
        remains: null, // нет фильрации на бэке
        stagesNumber: null,
        statuses: [],
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minPromotionDiscount: null,
        maxPromotionDiscount: null,
        minMargin: null,
        groupIds: [],
        categoryIds: [],
        // subcategoryIds: [],
        subcategoryId: null,
        // formatIds: [],
        formatId: null,
        regionIds: [],
        // regionId: null,
        clusterIds: [],
        // clusterId: null,
    };

    private prevFetchTableFilterValues: any = Object.assign({}, this.tableFilterValues);

    private listTableFields: any[] = [
        {
            module: 'promo',
            key: 'checkboxes',
            align: 'center',
            fixed: 'left',
            scopedSlots: {
                title: 'commonCheckbox',
                customRender: 'rowCheckbox',
            },
            width: 50,
        },
        {
            dataIndex: 'id',
            slots: { title: 'idColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('modules.table.headers.id') as string,
            },
            align: 'center',
            fixed: 'left',
            width: 76,
            ellipsis: true,
            filterModel: 'id',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'startDate',
            slots: { title: 'startDateColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('modules.table.headers.startDate') as string,
            },
            sorter: true,
            width: 184,
            ellipsis: true,
            // align: 'center',
            filterModel: 'startDate',
            // disabledDateMethod: current => current && new Date(current) < new Date().setUTCHours(0,0,0,0),
            disabledDateMethod: () => {},
            scopedSlots: {
                filterDropdown: 'filterDatepicker',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'endDate',
            slots: { title: 'endDateColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('modules.table.headers.endDate') as string,
            },
            sorter: true,
            width: 184,
            ellipsis: true,
            filterModel: 'endDate',
            // disabledDateMethod: current => current && new Date(current) < new Date().setUTCHours(0,0,0,0),
            scopedSlots: {
                filterDropdown: 'filterDatepicker',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'name',
            slots: { title: 'nameColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.moduleType === 'promo' ? this.$t('promo.promoName') as string : this.$t('sales.name') as string,
            },
            sorter: true,
            width: 250,
            ellipsis: true,
            filterModel: 'name',
            scopedSlots: {
                filterDropdown: 'filterInputTextCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'type',
            slots: { title: 'typeColumnTitle' },
            slotColumnTitleData: {
                text: this.moduleType === 'promo' ? this.$t('promo.promoType') as string : this.$t('sales.type') as string,
            },
            sorter: true,
            width: 190,
            ellipsis: true,
            filterOptions: 'types',
            filterModel: 'types',
            scopedSlots: {
                customRender: 'type',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'status',
            slots: { title: 'statusColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('modules.table.headers.statusColumn.headerName') as string,
            },
            sorter: true,
            filterOptions: 'statuses',
            filterModel: 'statuses',
            scopedSlots: {
                customRender: 'status',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
                title: 'titleCustom',
            },
            width: 140,
            ellipsis: true,
        },
        {
            dataIndex: 'groups',
            slots: { title: 'groupsColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('shared.filters.groupOfProduct') as string,
            },
            width: 170,
            ellipsis: true,
            filterOptions: 'groups',
            filterModel: 'groupIds',
            scopedSlots: {
                customRender: 'arrayOfIdAndNames',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'categories',
            slots: { title: 'categoriesColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('shared.filters.categoryOfProduct') as string,
            },
            width: 200,
            ellipsis: true,
            filterOptions: 'categories',
            filterModel: 'categoryIds',
            scopedSlots: {
                customRender: 'arrayOfIdAndNames',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'subcategory.name',
            slots: { title: 'subcategory.nameColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('shared.filters.subcategories') as string,
            },
            customRender: this.nameFormatter,
            width: 240,
            ellipsis: true,
            filterOptions: 'subcategories',
            filterModel: 'subcategoryId',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'format.name',
            slots: { title: 'format.nameColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('shared.filters.storeFormat') as string,
            },
            width: 200,
            ellipsis: true,
            filterOptions: 'storeFormats',
            filterModel: 'formatId',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'regions',
            slots: { title: 'regionsColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('shared.filters.storeRegion') as string,
            },
            // sorter: true,
            width: 200,
            ellipsis: true,
            filterOptions: 'storeRegions',
            filterModel: 'regionIds',
            scopedSlots: {
                customRender: 'arrayOfIdAndNames',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'clusters',
            slots: { title: 'clustersColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('shared.filters.storeCluster') as string,
            },
            // sorter: true,
            width: 200,
            ellipsis: true,
            filterOptions: 'storeClusters',
            filterModel: 'clusterIds',
            scopedSlots: {
                customRender: 'arrayOfIdAndNames',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'skuCount',
            slots: { title: 'skuCountColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('shared.labels.skuCount') as string,
            },
            sorter: true,
            customRender: this.valueUnknown,
            width: 180,
            ellipsis: true,
            filterModel: 'skuCount',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'remains',
            slots: { title: 'remainsColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('modules.table.headers.remains') as string,
            },
            sorter: true,
            customRender: this.valueUnknown,
            width: 120,
            ellipsis: true,
            filterModel: 'remains',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'taskId',
            slots: { title: 'taskIdColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('modules.table.headers.taskId') as string,
            },
            sorter: true,
            width: 170,
            filterModel: 'taskId',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            module: 'sales',
            dataIndex: 'stagesNumber',
            slots: { title: 'stagesNumberColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('sales.table.headers.stagesNumber') as string,
            },
            width: 200,
            ellipsis: true,
            sorter: true,
            filterModel: 'stagesNumber',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            module: 'sales',
            dataIndex: 'minSaleDiscount',
            slots: { title: 'minSaleDiscountColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('sales.table.headers.minSaleDiscount') as string,
            },
            width: 200,
            ellipsis: true,
            sorter: true,
            filterModel: 'minSaleDiscount',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon",
            },
        },
        {
            module: 'promo',
            dataIndex: 'minPromotionDiscount',
            slots: { title: 'minPromotionDiscountColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('promo.minPromoDiscount') as string,
            },
            width: 210,
            ellipsis: true,
            sorter: true,
            filterModel: 'minPromotionDiscount',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon",
            },
        },
        {
            module: 'sales',
            dataIndex: 'maxSaleDiscount',
            slots: { title: 'maxSaleDiscountColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('sales.table.headers.maxSaleDiscount') as string,
            },
            width: 200,
            ellipsis: true,
            sorter: true,
            filterModel: 'maxSaleDiscount',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon",
            },
        },
        {
            module: 'promo',
            dataIndex: 'maxPromotionDiscount',
            slots: { title: 'maxPromotionDiscountColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('promo.maxPromoDiscount') as string,
            },
            width: 220,
            ellipsis: true,
            sorter: true,
            filterModel: 'maxPromotionDiscount',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'minMargin',
            slots: { title: 'minMarginColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.moduleType === 'promo' ? this.$t('promo.minMargin') as string : this.$t('sales.table.headers.minMargin') as string,
            },
            width: 160,
            ellipsis: true,
            sorter: true,
            filterModel: 'minMargin',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'actions',
            title: this.$t('shared.labels.actions') as string,
            scopedSlots: { customRender: 'actions' },
            fixed: 'right',
            width: 140,
        },
    ];

    pagination: any = {
        current: 1,
        pageSize: 10,
        total: 0,
    }

    tableItems: Array<IModuleItemTableItem> = [];

    isTableLoading: boolean = false;

    private sortingFieldNames: { [key: string]: string } = {
        'groups': 'groupId',
        'categories': 'categoryId',
        'subcategory.name': 'subcategoryId',
        'format.name': 'formatId',
        'regions': 'regionId',
        'clusters': 'clusterId',
    };

    onTableChange(pagination: {current: number, pageSize: number}, filters: any, sorter: {order: string, field: string}) {
        if (sorter.field && sorter.order) {
            if (this.tableState.sortField && this.tableState.sortField !== 'id') { // this optimization, because on this page - impossible sort by id, and id is default (if possible sort by id - remove second condition)
                this.listTableFields.find(column => (this.sortingFieldNames[column.dataIndex] || column.dataIndex) === this.tableState.sortField).sortOrder = false;
            }

            this.listTableFields.find(column => column.dataIndex === sorter.field).sortOrder = sorter.order;

            this.tableState.sortField = this.sortingFieldNames[sorter.field] || sorter.field;
            this.tableState.isAsc = sorter.order === 'ascend';
        } else {
            this.listTableFields.forEach(column => {
                if (column.sortOrder) {
                    column.sortOrder = false;
                }
            })

            this.tableState.sortField = 'id';
            this.tableState.isAsc = false;
        }

        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;

        this.tableState.page = pagination.current - 1;
        this.tableState.size = pagination.pageSize;

        this.fetchItems();
    }

    fetchData(ignoreFilters: boolean = false) {
        if (this.filters.groupIds.length) {
            this.tableFilterValues.groupIds = this.filters.groupIds;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.groupIds = [];
            } else {
                this.tableFilterValues.groupIds = this.someFiltersStates.groupIds || [];
            }
        }

        if (this.filters.categoryIds.length) {
            this.tableFilterValues.categoryIds = this.filters.categoryIds;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.categoryIds = [];
            } else {
                this.tableFilterValues.categoryIds = this.someFiltersStates.categoryIds || [];
            }
        }

        if (this.filters.subcategory !== -1) {
            this.tableFilterValues.subcategoryId = this.filters.subcategory;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.subcategoryId = null;
            } else {
                this.tableFilterValues.subcategoryId = this.someFiltersStates.subcategoryId || null;
            }
        }

        if (this.filters.formatSelected !== -1) {
            this.tableFilterValues.formatId = this.filters.formatSelected;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.formatId = null;
            } else {
                this.tableFilterValues.formatId = this.someFiltersStates.formatId || null;
            }
        }

        if (this.filters.regionIds.length) {
            this.tableFilterValues.regionIds = this.filters.regionIds;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.regionIds = [];
            } else {
                this.tableFilterValues.regionIds = this.someFiltersStates.regionIds;
            }
        }

        if (this.filters.clusterIds.length) {
            this.tableFilterValues.clusterIds = this.filters.clusterIds;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.clusterIds = [];
            } else {
                this.tableFilterValues.clusterIds = this.someFiltersStates.clusterIds;
            }
        }

        this.fetchItems(ignoreFilters);
        this.fetchFilterOptions((this.filters.market && this.filters.market.id) || this.moduleData.selectMarket.id);
    }

    private nameFormatter(name: string | null): string {
        if (name != null) {
            return name
        }
        return this.$t('shared.selectBox.all') as string;
    }

    private valueUnknown(name: string | null | number): string | null | number {
        if (name != -1) {
            return name
        }
        return this.$t('shared.labels.undetermined') as string;
    }

    mounted() {
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchItems();
        this.fetchFilterOptions((this.filters.market && this.filters.market.id) || this.moduleData.selectMarket.id);
    }

    private toYesOrNoOmnichannel(value: boolean | null): string {
        if (value === null) {
            return ' '
        } else if (value) {
            return '{{ $t("shared.labels.yes") }}'
        } else {
            return '{{ $t("shared.labels.no") }}'
        }
    }

    private getFilterObjectWithServerFields(
        filterObject: { [key: string]: string | number | boolean | null }
    ): Record<string, string | number | boolean | null> {
        const serverFieldNames: Record<string, string> = {
            'statuses': 'status',
            'types': 'type',
            'groupIds': 'groupId',
            'categoryIds': 'categoryId',
            'regionIds': 'regionId',
            'clusterIds': 'clusterId',
            // 'subcategoryIds': 'subcategoryId', // в бэке только одна
            // 'formatIds': 'formatId', // в бэке только один
        };

        const resultObj: Record<string, string | number | boolean | null> = {};

        Object.keys(filterObject).forEach(filterKey => {
            resultObj[serverFieldNames[filterKey] || filterKey] = filterObject[filterKey];
        });

        return resultObj;
    }

    private resetItemsTableFilters() {
        this.$emit('reset-filters');

        this.tableFilterValues = Object.assign({}, this.defaultTableFilterValues);
        this.someFiltersStates = {};

        this.pagination.current = 1;

        this.tableState = Object.assign({}, this.defaultTableState);

        this.fetchItems();
    }

    private fetchItems(ignoreFilters: boolean = false) {
        if (!(this.filters.market && this.filters.market.id) || !this.moduleData.selectMarket.id) {
            return;
        }

        this.isTableLoading = true;

        const usualParams = {
          page: 0,
          size: 10,
          tradingId: (this.filters.market && this.filters.market.id) || this.moduleData.selectMarket.id,
          ...this.tableState,
        };

        const timezoneOffset: number = (new Date()).getTimezoneOffset() * 60000;

        const filters = !ignoreFilters ?
            this.getFilterObjectWithServerFields({
                ...this.tableFilterValues,
                startDate: this.tableFilterValues.startDate ? new Date (new Date(this.tableFilterValues.startDate as string).getTime() - timezoneOffset).toISOString().slice(0, 10) : null,
                endDate: this.tableFilterValues.endDate ? new Date (new Date(this.tableFilterValues.endDate as string).getTime() - timezoneOffset).toISOString().slice(0, 10) : null,
            })
            : {};

        this.api.fetchItemsWithFilters(this.moduleType, filters, usualParams)
            .then((resp) => {
                if (resp.status === 200) {
                    const array: IModuleItemTableItem[] = [];

                    resp.data.content.forEach((e: IModuleItemResponseDto) => {
                        array.push({
                            id: e.id,
                            tradingId: e.tradingId,
                            groups: e.groups,
                            categories: e.categories,
                            subcategory: e.subcategory,
                            clusters: e.clusters,
                            format: e.format,
                            regions: e.regions,
                            type: e.type,
                            status: e.status,
                            skuCount: e.skuCount,
                            remains: e.remains,
                            taskId: e.taskId,
                            startDate: e.startDate,
                            endDate: e.endDate,
                            name: e.name,
                            stagesNumber: e.stagesNumber,
                            minSaleDiscount: e.minSaleDiscount,
                            maxSaleDiscount: e.maxSaleDiscount,
                            minPromotionDiscount: e.minPromotionDiscount,
                            maxPromotionDiscount: e.maxPromotionDiscount,
                            minMargin: e.minMargin,
                            considerPlannedSeason: false, // временно, после доработок по бэку убрать and uncomment below
                            revaluationFileName: e.revaluationFileName,
                            // considerPlannedSeason: e.considerPlannedSeason,
                        })
                    })

                    this.tableItems = Object.assign([], array);

                    this.pagination.total = resp.data.totalElements;

                    if (this.moduleType === 'promo') {
                        this.prevFetchTableFilterValues = Object.assign({}, this.tableFilterValues);
                    }
                }
            })
            .catch(() => {
                this.showError(this.componentTexts[this.moduleType].fetchItemsError);
            })
            .finally(() => {
                this.isTableLoading = false;
            })
    }

    private fetchFilterOptions(tradingId: number) {
        if ((!this.filters.market || this.filters.market.id == null) && !this.moduleData.selectMarket.id) {
            return;
        }

        this.api.fetchFilterOptions(this.moduleType, tradingId)
            .then((resp: any) => {
                if (resp.status === 200) {
                    const filterOptions: { [key: string]: Array<{value: number | string, label: string}> } = {};

                    Object.keys(resp.data).forEach(key => {
                        if (['statuses', 'types'].includes(key)) {
                            filterOptions[key] = this.staticTableFilterOptions[this.moduleType][key as 'statuses' | 'types']
                                .filter(item => resp.data[key].includes(item.value));
                        } else {
                            filterOptions[key] = resp.data[key].map((option: {id: number, name: string}) => {
                                return {
                                    value: option.id,
                                    label: option.name,
                                };
                            });
                        }
                    });

                    this.tableFilterOptions = filterOptions;
                }
            })
            .catch(() => {
                this.showError(this.$t('shared.itemsList.errorFetchFilterOptions') as string);
            })
    }

    private openParametersTab(isExpanded: boolean, item: IModuleItemResponseDto) {
        this.$emit('open-params-tab', item);
    }

    private handelDeleteItem(item: IModuleItemTableItem) {
        Modal.confirm({
            title: this.$t('shared.messages.attention') as string,
            content: this.componentTexts[this.moduleType].deleteConfirmContent,
            centered: true,
            okText: this.$t('shared.buttons.yes') as string,
            cancelText: this.$t('shared.buttons.no') as string,
            onOk: () => {
                if (item.id != null) {
                    this.api.deleteItem(this.moduleType, item.id)
                        .then((resp) => {
                            if (resp.status === 200) {
                                this.showInfo(this.componentTexts[this.moduleType]!.deleteSuccess);
                                this.$emit('item-deleted', item.id);
                            }
                        })
                        .catch(() => {
                            this.showError(this.componentTexts[this.moduleType]!.deleteError);
                        });
                }
            },
        });
    }

    isValidDate(dateString: string, format: string = "YYYY-MM-DD") {
        return moment(dateString, format, true).isValid();
    }

    isValidPlanningPromoPeriod(item: IModuleItemTableItem): boolean {
        if (!this.isValidDate(item.startDate as string)
            || !this.isValidDate(item.endDate as string)
        ) {
            return false;
        }

        const startDate = moment(item.startDate as string)
        const endDate = moment(item.endDate as string)

        return !endDate.isBefore(startDate, 'days');
    }

    handleCalculateBtnClick(item: IModuleItemTableItem) {
        Modal.confirm({
            title: this.$t('shared.itemsList.confirmStartCalc') as string,
            content: this.$t('shared.itemsList.confirmStartCalcContent', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameDat') as string : this.$t('sales.typeNameDat') as string, id: item.id, name: item.name }) as string,
            centered: true,
            okText: this.$t('shared.itemsList.yesStart') as string,
            cancelText: this.$t('shared.labels.cancel') as string,
            onOk: () => {
                this.itemsCalculationStart(item);
            },
        });
    }

    itemsCalculationStart(item: IModuleItemTableItem) {
        if (!this.isValidPlanningPromoPeriod(item)) {
            this.showError(this.$t('shared.parametersTab.invalidPlanPeriod') as string)
            return;
        }

        const data = this.getModuleItemsFilter(item);

        this.httpPackageModuleItemsCalculationStart(this.moduleType, {
            ...data,
            saleId: this.moduleType === 'sales' ? item.id : null,
            promotionId: this.moduleType === 'promo' ? item.id : null,
            promotionName: this.moduleType === 'promo' ? item.name : null,
            minProfitability: item.minMargin,
            maxProfitability: data.maxMarginalProfit != null ? data.maxMarginalProfit : 100,
            minDiscount: this.moduleType === 'promo' ? item.minPromotionDiscount : item.minSaleDiscount,
            maxDiscount: this.moduleType === 'promo' ? item.maxPromotionDiscount : item.maxSaleDiscount,
            stagesNumber: item.stagesNumber,
            startDate: !!item.startDate
                ? moment.utc(item.startDate).startOf('day').valueOf()
                : null,
            endDate: !!item.endDate
                ? moment.utc(item.endDate).startOf('day').valueOf()
                : null,
        } as ModuleItemCalculationStartParams)
            .then((r) => {
                    this.showInfo(this.$t('shared.itemsList.calcStartedForItem', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameDat') as string : this.$t('sales.typeNameDat') as string, name: item.name }) as string);
                    this.$log.debug('Create task', r.data);
                },
            )
            .catch(() => {
                this.showError(this.$t('shared.itemsList.errorStartCalcForItem', { type: this.moduleType === 'promo' ? this.$t('promo.typeNameDat') as string : this.$t('sales.typeNameDat') as string, name: item.name }) as string);
            });
    }

    getSelectData(): [number[], number[], string[]] {
        const selectSeasons: number[] = (this.moduleData.seasonSelected.length === 0 || (this.moduleData.seasonSelected.length === 1 && this.moduleData.seasonSelected[0] === 0))
            ? []
            : LocalData.filterNumberArrays(this.moduleData.seasonSelected)!!;

        const selectBuyerSegment: number[] = (this.moduleData.buyerSegmentsList.length === 0 || (this.moduleData.buyerSegmentsList.length === 1 && this.moduleData.buyerSegmentsList[0] === 0))
            ? []
            : LocalData.filterNumberArrays(this.moduleData.buyerSegmentsList)!!;

        const selectedSku: string[] = (this.moduleData.selectedSkuList.length === 0 || this.moduleData.selectedSkuList.length === 1 && this.moduleData.selectedSkuList[0].value === null)
            ? []
            : (this.moduleData.selectedSkuList).filter((item) => item.value !== null).map((item) => {
                return (item.value);
            });

        return [selectSeasons, selectBuyerSegment, selectedSku];
    }

    prepareIndividualConfig(config: SaleIndividualConfig | PromotionIndividualConfig): SaleServerIndividualConfig | PromotionsServerIndividualConfig {
        const prepared: SaleServerIndividualConfig | PromotionsServerIndividualConfig = {};

        if ('minPrice' in config && typeof config.minPrice !== 'undefined' && config.minPrice != null) {
            prepared.minPrice = config.minPrice;
        }

        if ('maxPrice' in config && typeof config.maxPrice !== 'undefined' && config.maxPrice != null) {
            prepared.maxPrice = config.maxPrice;
        }

        if ('minProfitability' in config && typeof config.minProfitability !== 'undefined' && config.minProfitability != null) {
            prepared.minProfitability = config.minProfitability;
        }

        if ('minDiscount' in config && typeof config.minDiscount !== 'undefined' && config.minDiscount != null) {
            prepared.minDiscount = config.minDiscount;
        }

        if ('maxDiscount' in config && typeof config.maxDiscount !== 'undefined' && config.maxDiscount != null) {
            prepared.maxDiscount = config.maxDiscount;
        }

        if ('remains' in config && typeof config.remains !== 'undefined' && config.remains != null) {
            prepared.remains = config.remains;
        }

        return prepared;
    }

    prepareCommonIndividualConfig(config: IndividualConfig): CalcIndividualConfig {
        const prepared: CalcIndividualConfig = {};

        if ('kviStrategy' in config && typeof config.kviStrategy !== 'undefined' && config.kviStrategy !== null) {
            prepared.kviStrategy = config.kviStrategy.value
        }

        if ('marginalProfit' in config && typeof config.marginalProfit !== 'undefined' && config.marginalProfit != null) {
            prepared.marginalProfit = config.marginalProfit;
        }

        if ('selectCoefficent' in config && typeof config.selectCoefficent !== 'undefined' && config.selectCoefficent !== null) {
            const coef = config.selectCoefficent;
            prepared.coefficientK1 = coef.value.k1;
            prepared.coefficientK2 = coef.value.k2;
            prepared.priceOpt = coef.value.enum;
        }

        if ('priceIncreaseLimit' in config && typeof config.priceIncreaseLimit !== 'undefined' && config.priceIncreaseLimit != null) {
            prepared.priceIncreaseLimit = config.priceIncreaseLimit;
        }

        if ('competitorsPricesParams' in config && typeof config.competitorsPricesParams !== 'undefined' && config.competitorsPricesParams != null) {
            prepared.competitorsPricesParams = config.competitorsPricesParams;
        }

        if ('percentageOfCompetitorsPrice' in config) {
            prepared.percentageOfCompetitorsPrice = config.percentageOfCompetitorsPrice;
        }

        if ('periodPriceIncreaseLimit' in config && typeof config.periodPriceIncreaseLimit !== 'undefined' && config.periodPriceIncreaseLimit != null) {
            prepared.periodPriceIncreaseLimit = config.periodPriceIncreaseLimit;
        }

        if ('period' in config && typeof config.period !== 'undefined' && config.period !== null) {
            prepared.period = config.period.value;
        }

        if ('newProductPriceStrategy' in config && typeof config.newProductPriceStrategy !== 'undefined' && config.newProductPriceStrategy !== null) {
            prepared.newProductPriceStrategy = config.newProductPriceStrategy.value;
        }

        if ('priceGap' in config && typeof config.priceGap !== 'undefined' && config.priceGap != null) {
            prepared.priceGap = config.priceGap;
        }

        return prepared;
    }

    getModuleItemsFilter(item: IModuleItemTableItem): ModuleItemFilters {
        const [selectSeasons, selectBuyerSegment, selectedSku] = this.getSelectData();
        const allCheck = this.moduleData.allCheck;
        // const pennies = this.moduleData.pennies;
        const countAtLastPurchasePrice = this.moduleData.countAtLastPurchasePrice;
        const countAtFuturePurchasePrice = this.moduleData.countAtFuturePurchasePrice;
        // const allNewPricesWithoutPennies = this.moduleData.allNewPricesWithoutPennies;
        const allClaster = this.moduleData.allClaster;
        const individualConfigsObj = Object.create(null);
        const individualCommonConfObj = Object.create(null);

        for (const key in this.moduleData.individualConfig) {
            const value = this.moduleData.individualConfig[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }

        for (const key in this.moduleData.individualCommonParams) {
            const value = this.moduleData.individualCommonParams[key];
            if (typeof value !== 'undefined' && value != null) {
                individualCommonConfObj[key] = this.prepareCommonIndividualConfig(value);
            }
        }

        return {
            xyzChecked: this.moduleData.xyzChecked,
            uvwChecked: this.moduleData.uvwChecked,
            discountPrise: this.moduleData.discountPrice,
            allCheck,
            // pennies,
            countAtLastPurchasePrice,
            countAtFuturePurchasePrice,
            // allNewPricesWithoutPennies,
            allClaster,
            coefficientK1: this.moduleData.selectCoefficent.value.k1,
            coefficientK2: this.moduleData.selectCoefficent.value.k2,
            category: null,
            storeCluster: null,
            storeClusters: item.clusters.map(el => el.id).realValuesOrEmpty(),
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            spreadUVWParams: this.moduleData.uvwParams,
            spreadXYZParams: this.moduleData.xyzParams,
            storeRegionValues: item.regions.map(el => el.id).realValuesOrEmpty(),
            groupsOfProduct: item.groups.map(el => el.id).realValuesOrEmpty(),
            categories: item.categories.map(el => el.id).realValuesOrEmpty(),
            storeFormat: item.format.id,
            tradingId: item.tradingId!,
            calculationDepth: +this.moduleData.calculationDepth,
            correlation: this.moduleData.correlation ? this.moduleData.correlation : 0.7,
            highElasticity: this.moduleData.highElasticity ? this.moduleData.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.moduleData.intervalOfUltimateElasticity,
            competitorsPricesParams: this.moduleData.competitorsPrices,
            kviStrategy: this.moduleData.kviStrategy.value,
            percentageOfCompetitorsPrice: this.moduleData.percentageOfCompetitorsPrice,
            marginalProfitability: this.moduleData.marginalProfitability,
            marginalProfit: this.moduleData.marginalProfit,
            maxMarginalProfit: this.moduleData.maxMarginalProfit != null ? this.moduleData.maxMarginalProfit : 100,
            marginalPriceDifference: this.moduleData.marginalPriceDifference,
            calculationDay: +this.moduleData.calculationDay,
            priceCorridor: this.moduleData.priceCorridor,
            changePriceCorridor: this.moduleData.changePriceCorridor,
            priceIncreaseLimit: this.moduleData.priceIncreaseLimit,
            fixLowerBorder: this.moduleData.fixLowerBorder,
            individualCommonParams: individualCommonConfObj,
            depthToPurchasePrice: this.moduleData.depthToPurchasePrice,
            priceFamilies: this.moduleData.priceFamilies,
            hardPriceFamilies: this.moduleData.hardPriceFamilies,
            // groupOfProduct: this.moduleData.groupOfProduct,
            groupOfProduct: null,
            priceOpt: this.moduleData.selectCoefficent.value.enum!,
            subcategories: !item.subcategory || item.subcategory.id == null || item.subcategory.id <= 0 ? null : [item.subcategory.id],
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.moduleData.productSegments)!!,
            useCompetitorsPrices: this.moduleData.useCompetitorsPrices,
            byPromoPrices: this.moduleData.byPromoPrices,
            competitorsPricePeriod: this.moduleData.competitorsPricePeriod,
            competitorsCodes: this.moduleData.competitorsCodes,
            competitorsPriceMethod: this.moduleData.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.moduleData.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.moduleData.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.moduleData.competitorsMinimumProfit,
            competitorsMaximumProfit: this.moduleData.competitorsMaximumProfit != null ? this.moduleData.competitorsMaximumProfit : 100,
            competitorsControlParam: this.moduleData.competitorsControlParam,
            competitorsPriceStrategy: this.moduleData.competitorsPriceStrategy.value,
            // roundKviCompetitorPrice: this.moduleData.roundKviCompetitorPrice,
            calculateByRegression: !this.moduleData.calculateByElasticity,
            recalculateCtm: this.moduleData.recalculateCtm,
            individualPromoConfigs: individualConfigsObj,
            availableStockDelta: this.moduleData.availableStockDelta,
            promoInternalCodes: selectedSku,
            ...(this.moduleType === 'promo' ? { promoType: item.type! as PromoType } : {}),
            lift: this.moduleData.lift,
            purchasePrice: this.moduleData.purchasePrice,
            crossCalculation: this.moduleData.crossCalculation,
            newProductLifespanInDays: this.moduleData.newProductLifespanInDays,
            calculateCommon: this.moduleData.calculateCommon,
            intervalOfCorrelationElasticity: this.moduleData.intervalOfCorrelationElasticity,
            priceChangeLimit: this.moduleData.priceChangeLimit,
            priceChangeLimitKvi: this.moduleData.priceChangeLimitKvi,
            priceChangeLimitComp: this.moduleData.priceChangeLimitComp,
            useBrutForcingParams: false,
            saveAfterOptimize: false,
            optimizationDiff: 0.0,
            calculatePYR: this.moduleData.calculatePYR,
            calculationType: this.moduleType === 'promo' && this.calculationType ? this.calculationType.value : undefined,
            periodPriceIncreaseLimit: this.moduleData.periodPriceIncreaseLimit,
            period: this.moduleData.period.value,
            newProductPriceStrategy: this.moduleData.newProductPriceStrategy.value,
            priceGap: this.moduleData.priceGap,
            priceGapCtmPc: this.moduleData.priceGapCtmPc,
            findAutomaticallyPriceSegments: false,
            countPriceSegments: 1,
            considerPlannedSeason: this.moduleData.considerPlannedSeason,
            useDiscountDurationForForecastCalculation: this.moduleData.useDiscountDurationForForecastCalculation,
            useProductRange: this.moduleData.useProductRange,
            useSkuRotation: this.moduleData.useSkuRotation,
            promoCalc: true,
            percentageOfRecommendsKviCount: this.moduleData.percentageOfRecommendsKviCount,
            saveKviSign: this.moduleData.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.moduleData.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.moduleData.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.moduleData.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.moduleData.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: [],
            productCodesForDeleteKvi: [],
            productCodesForAddCtmPurpose: [],
            productCodesForDeleteCtmPurpose: [],
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            calculateCompAllowedDeviation: this.moduleData.calculateCompAllowedDeviation,
            minProfitKVI: this.moduleData.minProfitKVI,
            maxProfitKVI: this.moduleData.maxProfitKVI != null ? this.moduleData.maxProfitKVI : 100,
            productRangesAndInternalCodes: [],
            // randomPennies: this.moduleData.randomPennies,
            excludeOutOfStock: this.moduleData.excludeOutOfStock,
            calculateBySalePoints: this.moduleData.calculateBySalePoints,
            ...(this.moduleType === 'sales' ? { calculateBySubcategories: (this.moduleData as Sales).calculateBySubcategories } : {}),
            trainModel: this.moduleData.trainModel,
            considerCannibalization: this.moduleType === 'promo' ? (this.moduleData as Promotions).considerCannibalization : false,
            useCompElasticity: this.moduleData.useCompElasticity,
            // manualPennies: this.moduleData.manualPennies,
            forecastAccuracy: this.moduleData.forecastAccuracy,
            percentileType: this.moduleData.percentileType.value,
            calcWithBatchNumber: false,
            competitorPriceControlParameterPc: this.moduleData.competitorPriceControlParameterPc,
            thompsonSampling: false,
            revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
            inflation: this.moduleData.inflation,
            calculateBySpeedSale: this.moduleData.calculateBySpeedSale,
            isFixPricePromo: this.moduleData.isFixPricePromo,
            spreadByPriceSegments: this.moduleData.spreadByPriceSegments,
            rotationPeriodType: this.moduleData.rotationPeriodType,
            promoQuote: this.moduleData.promoQuoteValue,
            promoPriceCalculationDepth: this.moduleData.promoPriceCalculationDepth,
            useCompetitorsPromoPrices: this.moduleData.useCompetitorsPromoPrices,
            calculateCompAllowedDeviationPromo: this.moduleData.calculateCompAllowedDeviationPromo,
            competitorPriceControlParameterPcPromo: this.moduleData.competitorPriceControlParameterPcPromo,
            competitorsPricePeriodPromo: this.moduleData.competitorsPricePeriodPromo,
            competitorsPromoPriceInfluencesCoef: this.moduleData.competitorsPromoPriceInfluencesCoef,
            percentileTypePromo: this.moduleData.percentileTypePromo,
            competitorsPromoPriceAdjustment: this.moduleData.competitorsPromoPriceAdjustment,
            competitorsControlPromoParam: this.moduleData.competitorsControlPromoParam,
            competitorsPromoPriceMethod: this.moduleData.competitorsPromoPriceMethod
                ? this.moduleData.competitorsPromoPriceMethod.value
                : this.competitorsPromoPriceMethodsOpts[0].value,
            competitorsMinimumProfitPromo: this.moduleData.competitorsMinimumProfitPromo,
            competitorsMaximumProfitPromo: this.moduleData.competitorsMaximumProfitPromo != null ? this.moduleData.competitorsMaximumProfitPromo : 100,
            competitorsPromoPriceStrategy: this.moduleData.competitorsPromoPriceStrategy
                ? this.moduleData.competitorsPromoPriceStrategy.value
                : this.competitorsPromoPriceStrategiesOpts[0].value,
            planningPromoPeriodStartDate:
                !!item.startDate
                    ? moment.utc(item.startDate).startOf('day').valueOf()
                    : null,
            planningPromoPeriodEndDate:
                !!item.endDate
                    ? moment.utc(item.endDate).startOf('day').valueOf()
                    : null,
            minDefaultDiscount: item.minSaleDiscount || 0,
            maxDefaultDiscount: item.maxSaleDiscount || 0,
            priceDecreaseLimit: this.moduleData.priceDecreaseLimit,
            minPromoPrice: this.moduleData.minPromoPrice,
        };
    }

    getTableTypeLabel(typeValue: string | null = null) {
        const typeObj = this.moduleItemTypeOptions[this.moduleType].find(option => option.value === typeValue);

        return typeObj ? typeObj.label : this.$t('shared.labels.unknownType') as string;
    }

    resetIncludedAndExcludedCheckboxes() {
        this.includedIds = [];
        this.excludedIds = [];
    }

    isRowCheckboxChecked(id: number) {
        if (this.isCommonCheckboxSelected) {
            return !this.excludedIds.includes(id);
        } else {
            return this.includedIds.findIndex(includedId => includedId === id) > -1;
        }
    }

    handleRowCheckboxClicked(item: any, value: boolean) {
        if (this.isCommonCheckboxSelected) {
            if (value) {
                const index = this.excludedIds.findIndex(id => id === item.id);

                if (index > -1) this.excludedIds.splice(index, 1);
            } else {
                this.excludedIds.push(item.id);
            }
        } else {
            if (value) {
                this.includedIds.push(item.id);
            } else {
                const index = this.includedIds.findIndex(id => id === item.id);

                if (index > -1) this.includedIds.splice(index, 1);
            }
        }
    }

    handeExportBtnClick() {
        Modal.confirm({
            title: this.$t('shared.itemsList.confirmExportTitle') as string,
            content: this.$t('shared.itemsList.confirmExportContent', { count: this.selectedPromotionsCount }) as string,
            centered: true,
            okText: this.$t('shared.itemsList.yesExport') as string,
            cancelText: this.$t('shared.labels.cancel') as string,
            onOk: () => {
                const timezoneOffset: number = (new Date()).getTimezoneOffset() * 60000;

                this.api.exportPromotions({
                    filter: {
                        tradingNetId: this.moduleData.selectMarket.id,
                        // activeDate: '',
                        id: this.tableFilterValues.id,
                        startDate: this.tableFilterValues.startDate ? new Date (new Date(this.tableFilterValues.startDate as string).getTime() - timezoneOffset).toISOString().slice(0, 10) : null,
                        endDate: this.tableFilterValues.endDate ? new Date (new Date(this.tableFilterValues.endDate as string).getTime() - timezoneOffset).toISOString().slice(0, 10) : null,
                        statuses: this.tableFilterValues.statuses,
                        types: this.tableFilterValues.types,
                        name: this.tableFilterValues.name,
                        minPromotionDiscount: this.tableFilterValues.minPromotionDiscount,
                        maxPromotionDiscount: this.tableFilterValues.maxPromotionDiscount,
                        minMargin: this.tableFilterValues.minMargin,
                        remains: this.tableFilterValues.remains,
                        groupIds: this.tableFilterValues.groupIds,
                        categoryIds: this.tableFilterValues.categoryIds,
                        subcategoryIds: this.tableFilterValues.subcategoryId ? [this.tableFilterValues.subcategoryId] : [],
                        formatIds: this.tableFilterValues.formatId ? [this.tableFilterValues.formatId] : [],
                        regionIds: this.tableFilterValues.regionIds,
                        clusterIds: this.tableFilterValues.clusterIds,
                        promotionIds: [],
                    },
                    selectCheckboxesData: {
                        isCommonCheckboxSelected: this.isCommonCheckboxSelected,
                        includedIds: this.includedIds,
                        excludedIds: this.excludedIds,
                    },
                }).then((response) => {
                    this.showInfo(this.$t('shared.itemsList.exportSuccess') as string, 4);

                    const { fileName, fileContent } = response.data;

                    const bytes = Uint8Array.from(window.atob(fileContent), (char: string) => char.charCodeAt(0));
                    const blob = new Blob([bytes], { type: response.config.headers['Content-Type'] });

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');

                    link.href = url;
                    link.setAttribute('download', fileName);

                    document.body.appendChild(link);
                    link.click();

                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(link);

                    this.resetIncludedAndExcludedCheckboxes();
                    this.isCommonCheckboxSelected = false;
                }).catch(() => {
                    this.showError(this.$t('shared.itemsList.errorExport') as string);
                });
            },
        });
    }

    get selectedPromotionsCount(): number {
        if (this.moduleType === 'promo') {
            if (this.isCommonCheckboxSelected) {
                return this.pagination.total - this.excludedIds.length;
            } else {
                return this.includedIds.length;
            }
        } else {
            return 0;
        }
    }
}
